export default __webpack_public_path__ + "static/media/AssetG-terms_of_use.054b7ed8.pdf";